module.exports = __webpack_public_path__ + "static/jeremy-d0774462d1957cdcead099e6c9ba3dea.jpg";